export default __webpack_public_path__ + "167c5f860117bc35eecfcb47645132eb.svg";